import React from "react";
import PageHeader from "../components/marketing/PageHeader";
import Stats from "../components/marketing/Stats";
import AboutPreview from "../components/marketing/AboutPreview";
import EditorialMarquee from "../components/marketing/Marquee";
import { Reveal } from "../components/marketing/Reveal";
import { useContent } from "../context/ContentContext";
import { ACADEMY } from "../lib/constants";
import { Clock, Phone, Mail } from "lucide-react";

export default function About() {
  const { settings } = useContent();
  return (
    <div data-testid="about-page">
      <PageHeader
        overline="Our Story"
        title={<>The soul of <span className="italic gold-gradient-text">Rythmbara</span>.</>}
        subtitle="A dance institute where centuries-old classical traditions and contemporary movement live side by side — guided by passion, discipline and love for the art."
        image="https://images.pexels.com/photos/26856873/pexels-photo-26856873.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
      />
      <AboutPreview />
      <EditorialMarquee />
      <Stats settings={settings} />

      <section className="bg-background py-24 md:py-32">
        <div className="rb-container grid lg:grid-cols-2 gap-16">
          <Reveal>
            <p className="overline text-accent-foreground/60 mb-5 flex items-center gap-3">
              <span className="h-px w-10 bg-[var(--rb-gold)] inline-block" /> Meet the Master
            </p>
            <h2 className="font-serif font-light text-4xl md:text-5xl text-foreground leading-tight">{ACADEMY.master}</h2>
            <p className="mt-6 text-muted-foreground text-lg leading-relaxed">
              With years of dedicated training and stage experience, {ACADEMY.master} founded Rythmbara Dance Academy
              to share the transformative power of dance. Every class blends rigorous technique with the joy of
              expression, helping students of all ages discover their own rhythm.
            </p>
            <p className="mt-4 text-muted-foreground text-lg leading-relaxed">
              From a child's first steps to a senior student's arangetram, Rythmbara is a place to grow — artistically
              and personally.
            </p>
          </Reveal>

          <Reveal delay={0.15} className="bg-secondary p-8 md:p-10 border border-border">
            <h3 className="font-serif text-2xl text-foreground mb-6">Visit &amp; Timings</h3>
            <ul className="space-y-5 text-foreground">
              <li className="flex items-center gap-4"><Clock className="h-5 w-5 text-[var(--rb-gold)]" /> Morning: {ACADEMY.hours.morning}</li>
              <li className="flex items-center gap-4"><Clock className="h-5 w-5 text-[var(--rb-gold)]" /> Evening: {ACADEMY.hours.evening}</li>
              <li className="flex items-center gap-4"><Phone className="h-5 w-5 text-[var(--rb-gold)]" /> <a className="hover:text-[var(--rb-gold)]" href={`tel:${ACADEMY.phoneRaw}`}>{ACADEMY.phone}</a></li>
              <li className="flex items-center gap-4"><Mail className="h-5 w-5 text-[var(--rb-gold)]" /> <a className="hover:text-[var(--rb-gold)]" href={`mailto:${ACADEMY.email}`}>{ACADEMY.email}</a></li>
            </ul>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
